// Driver GraphQL queries and mutations for 8base
import { gql } from '@apollo/client';

export const DRIVERS_LIST = gql`
  query DriversList {
    driversList {
      items {
        id
        name
        licenseNumber
        phone
        status
      }
    }
  }
`;

export const DRIVER_GET = gql`
  query DriverGet($id: ID!) {
    driver(id: $id) {
      id
      name
      licenseNumber
      phone
      status
    }
  }
`;

export const DRIVER_CREATE = gql`
  mutation DriverCreate($data: DriverCreateInput!) {
    driverCreate(data: $data) {
      id
    }
  }
`;

export const DRIVER_UPDATE = gql`
  mutation DriverUpdate($data: DriverUpdateInput!) {
    driverUpdate(data: $data) {
      id
    }
  }
`;

export const DRIVER_DELETE = gql`
  mutation DriverDelete($id: ID!) {
    driverDelete(id: $id) {
      success
    }
  }
`; 